import React, { useState } from 'react';
import { Collapse } from 'reactstrap';

function ViewMyContact(props) {
    const [collapse, setCollapse] = useState(false);
    const toggle = () => setCollapse(!collapse);
    return (
    <div className="mg-t-20" >
        <div className="card" >
        <div className="card-header">
            <div className="card-header-left">
                <h5>Contact Information</h5>
            </div>
            <div className="card-header-right">
                <ul className="row" >                        
                      
                    <li><i className={collapse ? "fa fa-chevron-down" : "fa fa-chevron-up"} onClick={toggle}></i></li>                                 
                    
                </ul>                    
            </div>
        </div>         
        <Collapse isOpen={!collapse}> 
            <hr className="mg-l-20" ></hr>            
            <div className="card-block">
                <div className="row ">
                    <div className="row mg-l-5 pd-r-20 b-r-border mg-r-20 card-list-subheader" >
                        <div><i className="fas fa-location-arrow card-list-icon" ></i></div>
                        <div>
                            <div>Apt.# 2094, Windmills of Your Mind</div>
                            <div>331, Rd. 5B, Shivajinagar, EPIP Zone</div>
                            <div>Whitefield</div>
                            <div>Bangalore 560048</div>
                            <div>Karnataka, India</div>
                        </div>
                    </div>
                    <div className="row mg-l-5 pd-r-20 b-r-border mg-r-20 card-list-subheader" >
                        <div><i className="far fa-envelope card-list-icon" ></i></div>
                        <div>susmita.mq@gmail.com</div>
                    </div>
                    <div >
                        <div className="row mg-l-5 mg-b-15 card-list-subheader" >
                            <div><i className="fas fa-phone-alt card-list-icon" ></i></div>
                            <div>+91 9972810534</div>
                        </div>
                        <div className="row mg-l-5 card-list-subheader" >
                        <div><i className="fas fa-phone-alt card-list-icon" ></i></div>
                        <div>+91 9673548944</div>
                        </div>
                    </div>
                </div>
            </div>
        </Collapse>
    </div>
    </div>
        
    );
  }

export default ViewMyContact